import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Table } from "antd";
import { CurrencyFormat } from "../../../components/FormattersTS";
import { EditOutlined } from "@ant-design/icons";
import PermissionButton from "../../../components/PermissionButton";
import { DebtorInvoiceChargeTypeEnum } from "../../debtors/api/Representation";
const ConsignmentFreightBillingTable = ({ consignment, onEditNetFreight }) => {
    const columns = [{
            title: 'Invoice Text',
            dataIndex: 'invoiceText'
        }, {
            title: 'Invoice Qty',
            dataIndex: 'quantity',
            align: 'right'
        }, {
            title: 'Each (ex GST)',
            dataIndex: 'amountEachExTax',
            align: 'right',
            render: (value /*, charge: ConsignmentFreightResponse, index: number*/) => (_jsx(CurrencyFormat, { value: value }))
        }, {
            title: 'Total (ex GST)',
            dataIndex: 'amountTotalExTax',
            align: 'right',
            render: (value /*, charge: ConsignmentFreightResponse, index: number*/) => (_jsx(CurrencyFormat, { value: value }))
        }, {
            title: 'Action',
            key: 'action',
            render: (text, charge) => {
                if (consignment.debtorInvoiceApprovedAt || charge.chargeType != DebtorInvoiceChargeTypeEnum.CONSIGNMENT_FREIGHT) {
                    return "";
                }
                return (_jsx(PermissionButton, { permissions: ['admin:consignmentFreight:update'], onClick: () => onEditNetFreight(charge), children: _jsx(EditOutlined, {}) }));
            }
        }];
    return (_jsx(Table, { size: "small", columns: columns, dataSource: consignment.charges, bordered: true, pagination: false }));
};
export default ConsignmentFreightBillingTable;
